class InspectionMode {
    constructor(
      public presence: string,
      public type: string,
      public id?: number | undefined,
    ) {}
  
    public static EmptyInstance(): InspectionMode {
      return new InspectionMode("", "",  -1);
    }

    public static Display(inspection_mode: InspectionMode): string {
        let display_str = inspection_mode.type === "Other"
          ? "Other"
          : inspection_mode.type!;

        display_str +=  "(" + inspection_mode.presence + ")"
        return display_str;
    }
}

class InspectionModeInDTO {
    constructor(
        public inspection_mode_id: number,
        public description?: string
    ){}


    public static fromInspectionMode(im: InspectionMode, description: string): InspectionModeInDTO{
        return new InspectionModeInDTO(im.id !== undefined ? im.id : -1, description);
    }

    public static EmptyInstance(): InspectionModeInDTO {
        return new InspectionModeInDTO(-1, "");
    }
}

class InspectionModeOutDTO{
    constructor(
        public inspection_mode: InspectionMode,
        public description: string,
    ){}


    public static fromInspectionMode(inspection_mode: InspectionMode, description: string): InspectionModeOutDTO{
        return new InspectionModeOutDTO(inspection_mode, description);
    }

    public static EmptyInstance(): InspectionModeOutDTO {
        return new InspectionModeOutDTO(InspectionMode.EmptyInstance(), "");
    }

    public static Display(im: InspectionModeOutDTO): string {
        var second = im.inspection_mode.type === "Other"
        ? "Other"
        : im.inspection_mode.type!;

        return im.inspection_mode.presence +": " + second;
    }
}

export{
    InspectionMode,
    InspectionModeInDTO, 
    InspectionModeOutDTO,
}